import { Component, OnInit } from '@angular/core';
import {
  ApplicationState,
  getProductDetailsPending,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from '../../../../../store/reducers';
import { OnDestroyHookDirective } from '../../../../../shared/hooks';
import { Store } from '@ngrx/store';
import { GetProductDetails } from '../../../../../store/actions/product-details.actions';
import { Option, ProductTypes } from '@dch/products-business-logic';
import { getPiiServiceId } from '../../../../../shared/pii/pii.utils';
import { ActivatedRoute, Router } from '@angular/router';
import { InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-digitalis',
  templateUrl: './digitalis.component.html',
})
export class DigitalisComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  productDetails: any;
  selectedProduct: any;
  options: Option[];
  hasError = false;
  isPending = false;

  constructor(
    private store: Store<ApplicationState>,
    private route: ActivatedRoute,
    private inceptionService: InceptionService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store
          .select(getSelectedProductDetails)
          .subscribe((productDetails) => {
            if (productDetails) {
              this.productDetails = productDetails;
              this.selectedProduct =
                this.productDetails.digitalisProductDetails;
              this.options = this.selectedProduct.options;
            }
          }),
      );

      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: ProductTypes.DIGITALIS.toString(),
              serviceId,
            }),
          );
        }),
      );

      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );

      this.addSubscription(
        this.store.select(getProductDetailsPending).subscribe((pending) => {
          this.isPending = pending;
        }),
      );

      this.scrollToTop();
    } else {
      this.router.navigate(['/overview']);
    }
  }

  onSelectWebsite(accessNumber) {
    this.store.dispatch(
      new GetProductDetails({
        productType: ProductTypes.DIGITALIS.toString(),
        serviceId: accessNumber,
      }),
    );
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#digitalisDetails');
    });
  }
}
